import { ReactNode } from "react";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { useToggleState } from "use-toggle-state";

export interface ExpandableChartProps {
    children: ReactNode,
}

/**
 * Wraps a dashboard chart so that clicking it opens an enlarged copy of the same chart in a modal.
 */
export const ExpandableChart = (props: ExpandableChartProps) => {
    const { children } = props;

    const [modalIsOpen, toggleModal] = useToggleState();

    return (
        <>
            <div onClick={() => toggleModal()} style={{ cursor: 'pointer' }}>
                {children}
            </div>

            <Modal size="xl" isOpen={modalIsOpen} toggle={() => toggleModal()}>
                <ModalHeader toggle={() => toggleModal()} />
                <ModalBody>
                    <Row>
                        <Col>
                            {children}
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </>
    );
};
